import type { SessionResponse, SurveyResponse } from '@lms/api-client/backend';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@lms/ui/dialog';
import { useTranslations } from 'use-intl';
import TakeSurveyForm from './take-survey-form';

declare global {
  interface Window {
    API: any;
    API_1484_11: any;
  }
}

export default function BeforeSurvey({
  session,
  survey,
}: {
  session?: SessionResponse;
  survey: SurveyResponse;
}) {
  const t = useTranslations('player');

  return (
    <Dialog defaultOpen={true}>
      <DialogContent className="max-w-screen-md">
        <DialogHeader>
          <DialogTitle>{t('survey_before_title')}</DialogTitle>
        </DialogHeader>
        <TakeSurveyForm
          sessionId={session?.id}
          survey={survey}
          position="before_course"
        />
      </DialogContent>
    </Dialog>
  );
}
